import { useSelector } from 'react-redux';
import { LeftIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ReadyMadeReportsContainer from './ReadyMadeReportsContainer';
import requestStatusTypes from '../../constants/requestStatusTypes';
import AiReadyMadeReportsContainer from './AiReadyMadeReportsContainer';
import AiSearchCta from '../../components/fullscreenSearch/AiSearchCta';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error Untyped import
import { selectAiSearchRequestStatus } from '../../selectors/reportsSelector';
// @ts-expect-error Untyped import
import { selectGenerativeAIEnabled } from '../../selectors/aiSettingsSelector';
import { Section } from 'foundations-components/transitional/components/Section';
import SearchResultsHeader from '../../components/fullscreenSearch/SearchResultsHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReportTemplatesSearchSection = ({
  showMore,
  setShowMore
}) => {
  const hasAiSearchSettingsEnabled = useSelector(selectGenerativeAIEnabled);
  const aiSearchRequestStatus = useSelector(selectAiSearchRequestStatus);
  const handleBackToAllResultsClick = () => {
    setShowMore(false);
  };
  const getResultSections = () => {
    if (hasAiSearchSettingsEnabled) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(AiReadyMadeReportsContainer, {}), aiSearchRequestStatus !== requestStatusTypes.PENDING && aiSearchRequestStatus !== requestStatusTypes.UNINITIALIZED && /*#__PURE__*/_jsx(ReadyMadeReportsContainer, {
          showMore: showMore,
          setShowMore: setShowMore
        })]
      });
    } else {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(AiSearchCta, {}), /*#__PURE__*/_jsx(ReadyMadeReportsContainer, {
          showMore: showMore,
          setShowMore: setShowMore
        })]
      });
    }
  };
  return /*#__PURE__*/_jsxs(Section, {
    children: [showMore && /*#__PURE__*/_jsxs(Flex, {
      marginBlockEnd: "500",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(LeftIcon, {
        color: "icon-interactive-default"
      }), /*#__PURE__*/_jsx(Link, {
        onClick: handleBackToAllResultsClick,
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.globalSearch.backToAllResults"
        })
      })]
    }), /*#__PURE__*/_jsx(SearchResultsHeader, {
      headerKey: "reports.globalSearch.readyMadeReports"
    }), getResultSections()]
  });
};
export default ReportTemplatesSearchSection;